import type { RefObject } from 'react';
import { createContext } from 'react';

export const StickyContext = createContext<RefObject<HTMLElement> | null>(null);
